import { Table, Typography } from "antd"
import { PaymentFeeRow } from "./paymentFeesModel"

type Props = {
  rows: PaymentFeeRow[]
}

const columns = [
  { title: 'Payment method', dataIndex: 'method', key: 'method' },
  { title: 'Your processing cost', dataIndex: 'costText', key: 'costText' },
  {
    title: 'Maximum surcharge',
    key: 'maximumText',
    render: (_: unknown, row: PaymentFeeRow) => <>
      {row.maximumText}
      {row.note && <><br/><Typography.Text type="secondary">{row.note}</Typography.Text></>}
    </>
  }
]

const PaymentFeesTable = ({ rows }: Props) => {
  if (rows.length === 0) {
    return null
  }
  return <Table size="small" pagination={false} rowKey="key" columns={columns} dataSource={rows} />
}

export default PaymentFeesTable
